module.exports = __webpack_public_path__ + "static/media/icon_nav_reports_active.7fd48865.svg";